



























import {Component, Vue} from "vue-property-decorator";
import {TimeAssistantFeedback} from "@/entity/TimeAssistantFeedback";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {TimeAssistantFeedbackDto} from "@/dto/TimeAssistantFeedbackDto";

@Component({
  components: {},
})
export default class Feedback extends Vue {
  id = this.$route.params.id;
  timeAssistantFeedback = new TimeAssistantFeedback();
  su = SecurityUtils;

  async commit() {
    this.timeAssistantFeedback.timeAssistantId = this.id as unknown as number;
    this.timeAssistantFeedback.username = this.su.getLoginUser().username;
    this.timeAssistantFeedback.name = this.su.getLoginUser().name;
    this.timeAssistantFeedback.url = this.su.getLoginUser().avatarUrl;
    await TimeAssistantFeedbackDto.save(this.timeAssistantFeedback);
    this.timeAssistantFeedback = new TimeAssistantFeedback();
    this.$router.go(-1);
  }
}

